import React, { useState } from 'react';
import { Layout, Menu, Button, Drawer, Grid, Typography, Dropdown, Avatar } from 'antd';
import '../style/sidebarWrapper.css';
import {
    MenuOutlined,
    UserOutlined,
    SettingOutlined,
    LogoutOutlined
} from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { ROUTES } from '../helpers/constants';
import { useAuth } from '../authentication/authContext';

const { Sider, Content, Header } = Layout;
const { useBreakpoint } = Grid;
const { Title } = Typography;

const menuItems = [
    /* {
        key: 'dashboard',
        icon: <DashboardOutlined />,
        label: 'Dashboard',
        path: '/dashboard',
    }, */
    {
        key: 'admins',
        icon: <UserOutlined />,
        label: 'Admins',
        path: `/${ROUTES.ADMIN_LIST}`,
    },
    {
        key: 'users',
        icon: <UserOutlined />,
        label: 'Users',
        path: `/${ROUTES.USER_LIST}`,
    },
    /* {
        key: 'settings',
        icon: <SettingOutlined />,
        label: 'Settings',
        path: '/settings',
    }, */
    // Add more menu items as needed
];

export default function SidebarWrapper() {
    const { logOut } = useAuth();
    const [collapsed, setCollapsed] = useState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const screens = useBreakpoint();
    const location = useLocation();
    const navigate = useNavigate();

    const handleMenuClick = ({ key }) => {
        const item = menuItems.find(i => i.key === key);
        if (item) navigate(item.path);
        if (!screens.lg) setDrawerVisible(false);
    };

    const sidebar = (
        <>
            <div className="sidebar-title">
                <Title level={4} className="sidebar-title-text">{collapsed ? 'P' : 'Pinzpo Admin'}</Title>
            </div>
            <Menu
                mode="inline"
                selectedKeys={[menuItems.find(i => location.pathname.startsWith(i.path))?.key]}
                onClick={handleMenuClick}
                items={menuItems.map(({ key, icon, label }) => ({ key, icon, label }))}
                className="sidebar-menu"
            />
        </>
    );

    // User dropdown menu
    const userMenu = (
        <Menu>
            <Menu.Item key="setting" icon={<SettingOutlined />}>Setting</Menu.Item>
            <Menu.Item key="logout" onClick={logOut} icon={<LogoutOutlined />}>Logout</Menu.Item>
        </Menu>
    );

    // Example user name, replace with real user info if available
    const userName = 'Admin';

    return (
        <Layout className="sidebar-wrapper-layout">
            {screens.lg ? (
                <Sider
                    collapsible
                    collapsed={collapsed}
                    onCollapse={setCollapsed}
                    width={220}
                    className="sidebar-sider"
                >
                    {sidebar}
                </Sider>
            ) : (
                <Drawer
                    placement="left"
                    closable={false}
                    onClose={() => setDrawerVisible(false)}
                    open={drawerVisible}
                    className="sidebar-drawer"
                >
                    <div className='pz-drawer'>
                        <Button
                            type="text"
                            icon={<span style={{ fontSize: 22 }}>&#10005;</span>}
                            onClick={() => setDrawerVisible(false)}
                            aria-label="Close sidebar"
                        />
                    </div>
                    {sidebar}
                </Drawer>
            )}
            <Layout>
                <Header className="sidebar-header">
                    <div className="sidebar-header-left">
                        {!screens.lg && (
                            <Button
                                icon={<MenuOutlined />}
                                onClick={() => setDrawerVisible(true)}
                                className="sidebar-header-menu-btn"
                            />
                        )}
                    </div>
                    <div className="sidebar-header-right">
                        <Dropdown overlay={userMenu} placement="bottomRight" trigger={["click"]}>
                            <span className="sidebar-header-user">
                                <Avatar className="sidebar-header-avatar">{userName[0]}</Avatar>
                                <span>{userName}</span>
                            </span>
                        </Dropdown>
                    </div>
                </Header>
                <Content className="sidebar-content">
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
}
